// src/i18n/index.ts
import i18next, { i18n } from 'i18next'; // Importa a instância como i18next e a interface como i18n
import { initReactI18next } from 'react-i18next';

import ptBR from './locales/pt-BR';
import enUS from './locales/en-US';

i18next.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: ptBR },
    'en-US': { translation: enUS },
  },
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false,
  },
});

export const t = i18next.t.bind(i18next);

// O "as i18n" força o TS a exportar com as propriedades de instância corretas
export default i18next as i18n;